// @auto-index

import './styles.css'
import InlineLink from './InlineLink'

export { default as InlineLink } from './InlineLink'

export default InlineLink
